import React from 'react'

export const useClipboard = () => {
  const [isCopied, setIsCopied] = React.useState(false)
  const [isClipboardEnabled, setIsClipboardEnabled] =
    React.useState<boolean>(false)
  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null)

  React.useEffect(() => {
    if (!navigator.clipboard) return
    setIsClipboardEnabled(true)
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard?.writeText(text)

      setIsCopied(true)
      timeoutRef.current = setTimeout(() => setIsCopied(false), 1000)
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  }

  return {copyToClipboard, isCopied, isClipboardEnabled}
}
